import { cn } from "@omni/utils/styles";

import { SearchPagination } from "@/components/Search/SearchResults/StateComponents/Pagination/pagination.container";
import { SearchComponent } from "@/utils/search/types/searchComponent";

type Props = {
    className?: string;
};

const ProductPagination = ({ className }: Props) => (
    <SearchPagination
        className={cn(className)}
        resultListComponent={SearchComponent.PRODUCT_RESULT_LIST}
        paginationComponent={SearchComponent.PRODUCT_PAGINATION}
        hitsPerPageComponent={SearchComponent.PRODUCT_HITS_PER_PAGE}
        numberOfHitsComponent={SearchComponent.PRODUCT_NUMBER_OF_HITS}
    />
);
const ContentPagination = ({ className }: Props) => (
    <SearchPagination
        className={cn(className)}
        resultListComponent={SearchComponent.CONTENT_RESULT_LIST}
        paginationComponent={SearchComponent.CONTENT_PAGINATION}
        hitsPerPageComponent={SearchComponent.CONTENT_HITS_PER_PAGE}
        numberOfHitsComponent={SearchComponent.CONTENT_NUMBER_OF_HITS}
    />
);

export { ContentPagination, ProductPagination };
